import { render, staticRenderFns } from "./LinkJxcAccountSet.vue?vue&type=template&id=02cbeaf1&scoped=true"
import script from "./LinkJxcAccountSet.vue?vue&type=script&lang=js"
export * from "./LinkJxcAccountSet.vue?vue&type=script&lang=js"
import style0 from "./LinkJxcAccountSet.vue?vue&type=style&index=0&id=02cbeaf1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cbeaf1",
  null
  
)

export default component.exports